import { BlockchainName, DollarsAsString } from "../typings";

type WithdrawData = {
  address: string;
  amount: {
    crypto: string;
    fiat: {
      currency: "usd";
      amount: DollarsAsString;
    };
  };
  blockchainName: BlockchainName;
};

type Events = "withdraw";
export default class {
  private listeners = {};
  private events = ["withdraw"];
  on(eventName: Events, callback: (data: any) => void) {
    if (!this.events.includes(eventName)) return;
    this.listeners[eventName] = callback;
  }

  trigger(eventName: Events, args: WithdrawData) {
    if (!this.listeners[eventName]) return;
    this.listeners[eventName](args);
  }
}
